/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { TransmittalDocumentDto } from '../transmittalDocumentDto.schema';

export const IEnumerableOfTransmittalDocumentDto = zod.array(zod.lazy(() => TransmittalDocumentDto));

export type IEnumerableOfTransmittalDocumentDto = zod.input<typeof IEnumerableOfTransmittalDocumentDto>;
export type IEnumerableOfTransmittalDocumentDtoOutput = zod.output<typeof IEnumerableOfTransmittalDocumentDto>;
